import { render, staticRenderFns } from "./AdminPermissionSettings.vue?vue&type=template&id=522f7dc3&lang=pug&"
import script from "./AdminPermissionSettings.vue?vue&type=script&lang=js&"
export * from "./AdminPermissionSettings.vue?vue&type=script&lang=js&"
import style0 from "./AdminPermissionSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports